import L from 'leaflet';

// Utility function to extract style properties from feature
function getFeatureStyleProperties(feature) {
    return {
        color: feature.properties?.["stroke"] || "#0040ff",
        weight: feature.properties?.["stroke-width"] || 2,
        opacity: feature.properties?.["stroke-opacity"] ?? 0.8,
        fillColor: feature.properties?.["fill-color"] || "#0080ff",
        fillOpacity: feature.properties?.["fill-opacity"] ?? 0.2,
    };
}

// Utility function to create a GeoJSON layer
export function createGeoJsonLayer(fc, setState, selectedLayer) {
    return L.geoJSON(fc, {
        style: feature => getFeatureStyleProperties(feature),
        pointToLayer: (feature, latlng) =>
            L.marker(latlng, {
                ...getFeatureStyleProperties(feature),
            }),
        onEachFeature: (feature, layer) => {
            const popupText =
                feature.properties?.popupContent ||
                feature.properties?.featureTitle;
            if (popupText) {
                layer.bindPopup(popupText);
            }

            if (!selectedLayer) {
                setState({
                    selectedLayer: layer,
                    ...getFeatureStyleProperties(feature),
                    featureTitle: feature.properties?.["title"] || '',
                });
            }

            layer.on("mouseover", () => {
                layer.openPopup();
            });
            layer.on("mouseout", () => {
                layer.closePopup();
            });

            layer.on("click", () => {
                setState({
                    selectedLayer: layer,
                    ...getFeatureStyleProperties(feature),
                });                     
            });
        }
    });
}

// Utility function to center or fit bounds on the map
export function centerOrFitBounds(map, fc, zoom, mapPosition) {
    if (fc && Array.isArray(fc.features) && fc.features.length > 0) {
        if (
            fc.features.length === 1 &&
            fc.features[0].geometry?.type === 'Point'
        ) {
            const [lon, lat] = fc.features[0].geometry.coordinates;
            map.setView([lat, lon], zoom || 13, { animation: true });
        } else {
            const bounds = L.geoJSON(fc).getBounds();
            map.fitBounds(bounds, { padding: [40, 40] });
        }
    } else {
        map.setView(mapPosition, zoom, { animation: true });
    }
}